import { FileSharer } from '@byteowls/capacitor-filesharer';
import { Directory, Filesystem } from '@capacitor/filesystem';
import { Share } from '@capacitor/share';
import { useLoadingStore } from 'src/stores/loading';

import { blobToBase64 } from 'src/util/common/blobHelpers';
import { resolveMimeType } from 'src/util/common/mimeResolver';
import { isRunningInNativeCapacitorApp } from 'src/util/platform/browserInteractionCapabilities';
import { Callback } from 'src/util/query/models/Callback';

export class ShareTheTheDocumentQueryCallback extends Callback<Blob> {
	private readonly filename: string;

	constructor(filename: string) {
		super();
		this.filename = filename;
	}

	failureCallbackFunction = (failureResponse: unknown): void => {
		this.logFailureResponse(failureResponse);
	};

	successCallbackFunction = (successResponse: Blob): void => {
		void blobToBase64(successResponse).then((response) => {
			useLoadingStore().hide();

			const cleanBase64 = response.replace('data:', '').replace(/^.+,/, '');

			if (isRunningInNativeCapacitorApp()) {
				void Filesystem.writeFile({
					data: cleanBase64,
					directory: Directory.Cache,
					path: this.filename,
				})
					.then(() => {
						return Filesystem.getUri({
							directory: Directory.Cache,
							path: this.filename,
						});
					})
					.then((uriResult) => {
						void Share.share({
							title: this.filename,
							url: uriResult.uri,
						});
					});
				return;
			}

			void FileSharer.share({
				base64Data: cleanBase64,
				contentType: resolveMimeType(cleanBase64),
				filename: this.filename,
			});
		});
	};
}
